import * as actionTypes from "./actionTypes"
import {
    attivaSimSecondariaResponse,
    consipPlansInitialState,
    offertaRowDetails,
    ordiniConsipDetailsInitialState,
    ordiniConsipDetailsOfferta,
    ordiniConsipTableInitialState,
    simDaAttivareInitialState,
    simPrimariaInitialState,
    simSecondariaSummaryInitialState
} from "./helper";
import {updateObject} from "../../shared/utils/updateObject";

const initialState = {
    isCustomerConsip: false,
    ordiniConsipTableData: ordiniConsipTableInitialState,
    ordiniConsipDetails: ordiniConsipDetailsInitialState,
    simDaAttivare: simDaAttivareInitialState,
    daAttivareLoading: false,
    ordiniConsipDetailsOfferta: ordiniConsipDetailsOfferta,
    offerteRowDetails: offertaRowDetails,
    consipPlans: consipPlansInitialState,
    simPrimariaTable: simPrimariaInitialState,
    simSecondariaSummary: simSecondariaSummaryInitialState,
    attivaSimSecondariaResponse: attivaSimSecondariaResponse
}

const setIsCustomerConsip = (state, action) => {
    return updateObject(state, {
        isCustomerConsip: action.value
    })
}

const setOrdiniConsipData = (state, action) => {
    return updateObject(state, {
        ordiniConsipTableData: updateObject(state.ordiniConsipTableData,
            {[action.key]: action.value})
    })
}

const setOrdiniConsipDetails = (state, action) => {
    return updateObject(state, {
        ordiniConsipDetails: updateObject(state.ordiniConsipDetails,
            {[action.key]: action.value})
    })
}
const setOrdiniConsipDetailsOfferta = (state, action) => {
    return updateObject(state, {
        ordiniConsipDetailsOfferta: updateObject(state.ordiniConsipDetailsOfferta,
            {[action.key]: action.value})
    })
}

const setOfferteRowDetails = (state, action) => {
    return updateObject(state, {
        offerteRowDetails: updateObject(state.offerteRowDetails,
            {[action.key]: action.value})
    })
}

const setSimDaAttivare = (state, action) => {
    return updateObject(state, {
        simDaAttivare: action.value
    });
}

const setSimDaAttivareLoading = (state, action) => {
    return updateObject(state, {
        daAttivareLoading: action.value
    });
}

const setConsipPlans = (state, action) => {
    return updateObject(state, {
        consipPlans: updateObject(state.consipPlans,
            {[action.key]: action.value})
    })
}

const setSimPrimariaDataAndLoading = (state, action) => {
    return updateObject(state, {
        simPrimariaTable: updateObject(state.simPrimariaTable,
            {[action.key]: action.value})
    })
}

const setSimSecondariaSummary = (state, action) => {
    return updateObject(state, {
        simSecondariaSummary: updateObject(state.simSecondariaSummary,
            {[action.key]: action.value})
    })
}

const setAttivaSimSecondariaResponse = (state, action) => {
    return updateObject(state, {
        attivaSimSecondariaResponse: updateObject(state.attivaSimSecondariaResponse,
            {[action.key]: action.value})
    })
}


const ordiniConsipReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_IS_CUSTOMER_CONSIP:
            return setIsCustomerConsip(state, action)
        case actionTypes.GET_ORDINI_CONSIP_TABLE_DATA_AND_LOADING:
            return setOrdiniConsipData(state, action)
        case actionTypes.GET_ORDINI_CONSIP_DETAILS:
            return setOrdiniConsipDetails(state, action)
        case actionTypes.GET_ORDINI_CONSIP_DETAILS_OFFERTA:
            return setOrdiniConsipDetailsOfferta(state, action)
        case actionTypes.GET_OFFERTA_ROW_DETAILS:
            return setOfferteRowDetails(state, action)
        case actionTypes.GET_SIM_DA_ATTIVARE:
            return setSimDaAttivare(state, action)
        case actionTypes.GET_SIM_DA_ATTIVARE_LOADING:
            return setSimDaAttivareLoading(state, action)
        case actionTypes.GET_CONSIP_PLAN_AND_LOADING:
            return setConsipPlans(state, action)
        case actionTypes.GET_SIM_PRIMARIA_DATA_AND_LOADING:
            return setSimPrimariaDataAndLoading(state, action)
        case actionTypes.GET_SIM_SECONDARIA_SUMMARY_DATA:
            return setSimSecondariaSummary(state, action)
        case actionTypes.ATTIVA_SIM_SECONDARIA_REQUEST:
            return setAttivaSimSecondariaResponse(state, action)
        default:
            return state;
    }
}

export default ordiniConsipReducer;